var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmallLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9313 15.7363C24.7332 12.7058 23.5351 9.60483 22.4075 6.57433C21.7732 4.95336 21.1389 3.3324 20.5046 1.71143C20.4342 1.57048 20.3637 1.5 20.2227 1.5C19.9408 1.5 19.5884 1.5 19.3065 1.5C19.2361 1.5 19.0951 1.57048 19.0951 1.64095C18.3199 3.54383 17.6151 5.51717 16.8398 7.42005C15.9941 9.60483 15.1484 11.8601 14.3027 14.0449C14.0208 14.8201 13.7389 15.5953 13.3865 16.4411C13.5274 16.4411 13.5274 16.4411 13.5979 16.4411C14.1617 16.4411 14.7255 16.4411 15.2893 16.4411C15.5008 16.4411 15.5713 16.3706 15.6417 16.2296C16.1351 14.8906 16.6284 13.5515 17.1217 12.2829L18.1084 9.53435V9.46387C18.2494 9.18196 18.3198 8.82958 18.4608 8.54767C18.8132 7.63148 19.1656 6.6448 19.5179 5.7286C19.5884 5.58765 19.5884 5.4467 19.6589 5.23527C19.8703 5.79908 20.0818 6.29242 20.2227 6.78576C20.5751 7.70195 20.857 8.54767 21.2094 9.46387V9.53435L22.0551 11.8601C22.0551 11.8601 22.0551 11.8601 22.0551 11.9306C22.6189 13.4106 23.1123 14.8906 23.6761 16.3001C23.7466 16.4411 23.817 16.5115 23.958 16.5115C24.5923 16.5115 25.1561 16.5115 25.7904 16.5115C25.8609 16.5115 25.9313 16.5115 26.0018 16.5115C26.0723 16.2296 26.0018 15.9477 25.9313 15.7363Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2825 36.5972H14.8386V38.5H24.2825V36.5972Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2825 30.1133H14.8386V32.0162H24.2825V30.1133Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.283 23.5591H14.8391V25.462H24.283V23.5591Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogo);
export default __webpack_public_path__ + "static/media/small-logo.c7b2e86b.svg";
export { ForwardRef as ReactComponent };